import { NewProjectBasicsForm } from '@/business/project/models/new-project-basics-form'
import { maxLength, propertyMapping, PropertyMapping, required } from '@hakla/typed-forms'
import { ProjectResponse, ResourceVariant } from '@/api/generated'
import { updateOrAppend } from '@/shared/utils/list'

export interface NewProjectForm {
  about: NewProjectBasicsForm

  description: {
    description: string
  }

  header: {
    resources: ResourceVariant[]
  }
}

export function newProjectFormMapping(): PropertyMapping<ProjectResponse, NewProjectForm> {
  return propertyMapping(({ nested }) => {
    const about = nested('about')

    return {
      about: about.properties(({ generic }) => {
        return {
          categories: generic('categories'),

          logo: generic('logo').serializeWith((model, form) => {
            model.resources = updateOrAppend(
              model.resources || [],
              {
                name: 'logo',
                resources: [form.logo],
              },
              (a, b) => a.name === b.name
            )
          }),

          name: generic('name').validations(required),
          shortDescription: generic('shortDescription').validations(maxLength(300)),
        }
      }),

      description: nested('description').properties(({ generic }) => {
        return {
          description: generic('description').validations(required),
        }
      }),

      header: nested('header', 'resources').properties(({ generic }) => {
        return {
          resources: generic('resources')
            .initializeWith([])
            .serializeWith((model, form) => {
              model.resources = updateOrAppend(
                model.resources || [],
                {
                  name: 'header',
                  resources: form.resources,
                },
                (a, b) => a.name === b.name
              )
            }),
        }
      }),
    }
  })
}
